import axios from "axios";
import Swal from "sweetalert2";
import format from 'date-fns/format';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Base URL to call API service
// Localhost
// export const BASE_URL = 'http://localhost:8000/';
// export const BASE_URL = 'http://192.168.1.148:8000/'
// Live
export const BASE_URL = 'https://highoctavez.org:8000/';

// URL for redirection after payments
// Localhost
// export const RETURN_URL = 'http://localhost:3000/#';

// Live
export const RETURN_URL = 'https://highoctavez.org/#';

export const exceptThisSymbols = ["e", "E", "+", "-", "."];

export const getToken = () => {
    return sessionStorage.getItem('token')
}

export const handleStorage = (id) => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('page_id', id);
}

export const TotalDonation = (id) => {
    return axios({
        method: 'get',
        url: BASE_URL + 'project/projectgoal/' + id,
    })
}

export const Loading = (status) => {
    if (status) {
        // document.body.setAttribute('style','overflow:hidden;height:100vh');
        return (
            <div className=''>
                <div className="loading">Loading&#8230;
                </div>


            </div>
        )
    } else {
        document.body.setAttribute('style', 'overflow:visible;');
    }
}

export const ErrConnection = () => {
    return (
        Swal.fire({
            text: 'Error Internet Connection',
            icon: 'warning',
            showConfirmButton: false,
            toast: true,
            timer: 1500
        })
    )
}

export const DateFormat = (date) => {
    if (date) {
        return format(
            new Date(date),
            'dd-MM-yyyy'
        )
    }
}

export const fileUpload = (progress) => {
    if (Number(progress) !== 0) {
        toast('', { toastId: 'progressToast' });

        toast.update('progressToast', {
            render: (
                <div>
                    <div>files uploading <span className='text-success'>{progress}% </span></div>
                    <div className="skill-bar class-bar">
                        <div className="skill-bar-inner class-bar-in" style={{ width: `${progress}%` }} />
                    </div>
                </div>)
        })
    }
    if (Number(progress) === 100) {
        toast.update('progressToast', {
            render: (
                <div>
                    <div>files Uploaded <span className='text-success'>{progress}% </span></div>
                    <div className="skill-bar class-bar">
                        <div className="skill-bar-inner class-bar-in" style={{ width: `${progress}%` }} />
                    </div>
                </div>)
        })
        setTimeout(() => {
            toast.dismiss();
        }, 500);
    }
}

const donationExe = (event) => {
    let value = { "return_url": RETURN_URL + "/executedonation", "cancel_url": RETURN_URL + event.path }
    localStorage.setItem('navigate', event.path)
    event.loading(true);
    !event.mobile_no && (event.mobile_no = null)
    //project ID 0 for common donation
    let data = { ...event, ...value }
    axios({
        url: BASE_URL + 'donation/getToken',
        method: 'post',
        data: data,
        headers: {
            "Content-Type": "application/json",
            // 'Authorization': `bearer ${getToken()}`
        },
    }).then((response) => {
        localStorage.setItem('invoice', response.data['invoice']);
        window.open(response.data['url'], "_self");
        event.loading(false);
    }).catch((msg) => {
        console.log(msg);
        
        event.loading(false);
        if (msg.response.status === 503) {
            Swal.fire({
                icon: 'error',
                toast: true,
                showConfirmButton: false,
                timer: 2500,
                text: msg.response?.data?.detail ? msg.response?.data?.detail+'! Contact Admin' : 'Something went wrong ' + msg.response.status,
            })
        }else {
            Swal.fire({
                icon: 'error',
                toast: true,
                showConfirmButton: false,
                timer: 2500,
                text: 'Something went wrong! contact admin',
            })
        }
    })
}

export const donation = (register, errors, handleSubmit) => {
    return (
        <div className="modal fade" id="donationModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1">
            <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content make_donation_box">
                    <div className="modal-header">
                        <div className='col-lg-4'>
                            {/* <button type="button" className='btn btn-secondary' data-bs-target="#donation2" data-bs-toggle="modal" data-bs-dismiss="modal" style={{ borderRadius: '50%', color: 'white' }}><i className='fa fa-arrow-left' ></i></button> */}
                        </div>
                        <div className='col-lg-4'>
                            <h3 className='text-nowrap'> Make Donation</h3>
                        </div>
                        <div className='col-lg-4 text-end'>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                    </div>
                    <form id="add_donation" onSubmit={handleSubmit(donationExe)}>
                        <div className="modal-body text-start">
                            <div className='col-lg-10 mx-auto'>
                                <div className=' mb-2'>
                                    <label htmlFor="recipient-name" className="col-form-label">Your Name<span className='text-danger'>*</span></label>
                                    {/* <input type="text" className="form-control" name="name" value={edit.name} onChange={handleUpdateChange} /> */}
                                    <input type="text" className="form-control donation-form" name="username"
                                        {...register("username", { required: true, pattern: /^[A-Za-z ]+$/ })}
                                        aria-invalid={errors.username ? "true" : "false"} />
                                    {errors.username?.type === 'required' && <div className='text-danger'>Name is required</div>}
                                    {errors.username?.type === 'pattern' && <div className='text-danger'>Name can contain only alphabets</div>}
                                </div>
                                <div className=' mb-2'>
                                    <label htmlFor="recipient-name" className="col-form-label">Your Email ID<span className='text-danger'>*</span></label>
                                    {/* <input type="text" className="form-control" name="name" value={edit.name} onChange={handleUpdateChange} /> */}
                                    <input type="text" className="form-control donation-form" name="email"
                                        {...register("email", { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i })}
                                        aria-invalid={errors.email ? "true" : "false"} />
                                    {errors.email?.type === 'pattern' && <div className='text-danger'>Enter valid Email</div>}
                                    {errors.email?.type === 'required' && <div className='text-danger'>Email is required</div>}
                                </div>
                                <div className=' mb-2'>
                                    <label htmlFor="recipient-name" className="col-form-label">Your Mobile No</label>
                                    {/* <input type="text" className="form-control" name="name" value={edit.name} onChange={handleUpdateChange} /> */}
                                    <input type="text" className="form-control donation-form" name="mobile_no"
                                        {...register("mobile_no", { required: false, pattern: /^[+-]?\d*(?:[.,]\d*)?$/, minLength: 10, maxLength: 12 })}
                                        aria-invalid={errors.email ? "true" : "false"} />
                                    {errors.mobile_no?.type === 'pattern' && <div className='text-danger'>Enter valid Mobile No</div>}
                                    {errors.mobile_no?.type === 'minLength' && <div className='text-danger'>Enter valid Mobile No</div>}
                                    {errors.mobile_no?.type === 'maxLength' && <div className='text-danger'>Enter valid Mobile No</div>}
                                </div>

                                <div className='mb-2'>
                                    <label htmlFor="recipient-name" className="col-form-label">Amount ($)<span className='text-danger'>*</span></label>
                                    <input type="text" className="form-control donation-form" name="amount"
                                        {...register("amount", { required: true, min: 1, pattern: /^[+-]?\d*(?:[.]\d*)?$/ })}
                                        aria-invalid={errors.amount ? "true" : "false"} />
                                    {errors.amount?.type === 'required' && <div className='text-danger'>Amount is required</div>}
                                    {errors.amount?.type === 'min' && <div className='text-danger'>Please enter more than or equal to $1</div>}
                                    {errors.amount?.type === 'pattern' && <div className='text-danger'>Enter valid Amount</div>}
                                </div>
                            </div>
                        </div>
                        <div className="text-center mb-3">
                            <button className="btn btn_theme" style={{ align: 'center' }}>Proceed to Pay</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export function FileInput({ name, fileList, setFileList, type, error }) {

    const note = type === 'image' ? { type: '.jpg, .jpeg, .png', size: '5MB', extension: /(\.jpg|\.jpeg|\.png|\.gif)$/i, sizeint: 5e6 } : type === "video" ? { type: '.mp4', size: '10MB', extension: /(\.mp4)$/i, sizeint: 10e6 } : { type: '', size: '', extension: '', sizeint: '' }

    const handleFileChange = async (e) => {
        e.preventDefault();
        let files = e.target.files;
        let fileError = []
        const list = [...fileList];

        var allowedExtensions = note?.extension;

        await Object.keys(files).forEach(key => {

            if (files[key].size > note?.sizeint || !allowedExtensions.exec(files[key].name)) {
                fileError.push(files[key].name);
            }
            else {
                if (!list.some((file) => file.name === files[key].name && file.size === files[key].size)) {
                    list.push(files[key])
                }

            }
        })
        setFileList(list)
        if (fileError.length > 0) {
            Swal.fire({
                text: `${fileError.length} failed to upload`,
                showConfirmButton: false,
                toast: true,
                showCloseButton: true,
                icon: 'info',
                timer: '1700'
            })
        }
        document.getElementById(name).value = null
    };

    const removeSelected = (index) => {
        const temp = [...fileList];
        temp.splice(index, 1)
        setFileList(temp)
    }

    return (
        <div>
            <button
                type='button'
                className="btn form-control border-secondary d-flex p-0 align-items-center"
                onClick={() => { document.getElementById(name).click() }} >
                <div className='px-3 p-1 border border-left' style={{ backgroundColor: '#d6faf2c4' }}>
                    {fileList?.length ? "Add another files" : "Choose file"}
                </div>
                <span className='mx-3'>{fileList?.length ? `${fileList?.length} files` : "No files"}</span>
            </button>
            <input
                name="file"
                id={name}
                type='file'
                placeholder='Choose an image'
                className='form-control'
                accept={note?.type}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                multiple
            />
            {error && <div className="text-danger mt-1">Select image to upload</div>}
            <div className='col-lg-12' style={{ minHeight: '30px', maxHeight: '180px', overflow: 'auto' }}>
                {fileList?.length > 0 && <div className="form-group">
                    <div className='edit-gallery-image my-3'>
                        {fileList?.map((image, index) => {
                            return (
                                <div className='image_part' key={index}>

                                    {type === "image" ?
                                        <img src={URL?.createObjectURL(image)} alt='GalleryImage' style={{ objectPosition: 'top', objectFit: 'cover', height: '70px', width: '70px' }} />
                                        :
                                        <video src={URL?.createObjectURL(image)} alt='GalleryImage' style={{ objectPosition: 'top', objectFit: 'cover', height: '70px', width: '70px' }} />
                                    }
                                    <div className="overlay" style={{ cursor: 'pointer' }} onClick={() => removeSelected(index)} >
                                        <i style={{ fontSize: '20px' }} className="fa fa-trash fa-sm icon" title='Click to delete'></i>
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                </div>}
            </div>
            <div className='small text-danger'>
                <span className='fw-bold text-secondary'>Note :</span><br /> Accepted files are {note?.type} <br /> Maximum size is {note?.size}
            </div>
        </div>
    )
}